import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { SectionLabel, FadeUp } from "@/components/Reveal";
import Lightbox from "@/components/Lightbox";
import GalleryFrame from "@/components/GalleryFrame";
import Marquee from "@/components/Marquee";
import { GALLERY_ALL } from "@/data/site";
import { track } from "@/lib/track";
import { useLang } from "@/i18n/LanguageContext";

const GalleryPage = () => {
  const [lb, setLb] = useState(null);
  const { t } = useLang();
  const navLb = (d) =>
    setLb((i) => (i + d + GALLERY_ALL.length) % GALLERY_ALL.length);

  const images = GALLERY_ALL.map((img) => ({
    ...img,
    ...(t.gallery.images[img.key] || {}),
  }));

  return (
    <main data-testid="gallery-page" className="bg-midnight">
      <div className="mx-auto max-w-[1680px] px-6 pb-16 pt-32 lg:px-12 lg:pt-40">
        <SectionLabel index="" text="HUDSON & STIR" />
        <FadeUp delay={0.1}>
          <h1 className="mt-8 font-serif text-5xl font-light leading-[1.05] text-ivory md:text-6xl">
            {t.gallery.pageTitlePre}<span className="italic text-gold">{t.gallery.pageTitleEm}</span>
          </h1>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-lg font-sans text-sm font-light leading-relaxed text-ivory/50">
            {t.gallery.pageSub}
          </p>
        </FadeUp>
      </div>

      <section className="relative overflow-hidden border-y border-gold/10" data-testid="gallery-page-frame-section">
        <img
          src="/images/stir/sketch-gallery.jpg"
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-[50%_32%]"
        />
        <div className="absolute inset-0 bg-[#F4F0EA]/25" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1680px] px-6 py-16 lg:px-12 lg:py-24">
          <FadeUp delay={0.1}>
            <GalleryFrame
              images={images}
              testid="gallery-page-frame"
              onOpen={(i) => {
                setLb(i);
                track("gallery_opened", { image: images[i].caption, location: "gallery_page" });
              }}
            />
          </FadeUp>
        </div>
      </section>

      <div className="mx-auto max-w-[1680px] px-6 lg:px-12">
        <FadeUp className="flex flex-col items-center py-20 text-center">
          <p className="font-serif text-2xl font-light italic text-ivory/70">
            {t.gallery.pageCta}
          </p>
          <Link
            to="/quote"
            data-testid="gallery-page-quote-btn"
            className="mt-8 bg-gold px-12 py-4 font-sans text-[11px] tracking-[0.3em] text-midnight transition-colors duration-300 hover:bg-gold-light"
          >
            {t.quoteCta}
          </Link>
        </FadeUp>
      </div>
      <Marquee />

      <AnimatePresence>
        {lb !== null && (
          <Lightbox
            images={images}
            index={lb}
            onClose={() => setLb(null)}
            onNav={navLb}
          />
        )}
      </AnimatePresence>
    </main>
  );
};

export default GalleryPage;
